import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'kh-search-field',
    styleUrls: ['./search-field.component.less'],
    templateUrl: './search-field.component.html',
    standalone: false
})
export class SearchFieldComponent {
  public controlValue = new UntypedFormControl('');

  @Input() public placeholder = '';
  @Output() public submit = new EventEmitter<string>();
  @Input()
  public set searchValue(text: string) {
    this.controlValue.setValue(text, {emitEvent: false});
  }

  public search(): void {
    this.submit.next(this.controlValue.value);
  }
}
